import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import { Box } from '@mui/material';

// function handleClick(event: React.MouseEvent<HTMLDivElement, MouseEvent>) {
//   event.preventDefault();
// }

export default function Breadcrumb({ items, handleClick }: any) {
    if (items.length === 0) return null;
    return (
        <Breadcrumbs aria-label="breadcrumb">
            {items.map((item: any, index: any) => {
                const onClick = (e: any) => {
                    if (!e) return;
                    //@ts-ignore
                    e.preventDefault();
                    //@ts-ignore
                    e.stopPropagation();
                    handleClick(index);
                };
                return (
                    <Link key={index} underline={index === items.length - 1 ? 'none' : 'hover'} color="inherit" href={item.url}>
                        <Box color="text.primary" onClick={onClick} sx={{ cursor: index === items.length - 1 ? 'default' : 'pointer', fontWeight: index === items.length - 1 ? 'bold' : 'normal' }}>
                            {item.name}
                        </Box>
                    </Link>
                );
            })}
        </Breadcrumbs>
    );
}
